<template lang="">
  <div>
    <AccountSignupForm/>
  </div>
</template>

<script>
import AccountSignupForm from '@/components/account/AccountSignupForm.vue';

export default {
  components: {
    AccountSignupForm
  }
}
</script>
<style lang="">
    
</style>